import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { CustomButton, Icon } from 'src/components/ui'
import { useCreateBottle } from 'src/zustand/stores/createBottle.store'

import styles from './ChooseTypeOfBottles.module.scss'
import { useTypeOfBottle } from './hooks/useTypesOfBottle'

interface Props {}

const ChooseTypeOfBottle: React.FC<Props> = () => {
  const TYPES_OF_BOTTLE = useTypeOfBottle()
  const bottleType = useCreateBottle((state) => state.bottleType)
  const addTypeOfBottle = useCreateBottle((state) => state.addTypeOfBottle)

  const [activeType, setActiveType] = React.useState<string>(bottleType)

  const { t } = useTranslation()
  const navigate = useNavigate()

  const addTypeIntoStorage = () => {
    addTypeOfBottle(activeType)
    navigate(activeType === 'Lottery' ? '/create-bottle/step-2?type=lottery' : '/create-bottle/step-2?type=charitable')
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapper_body}>
        <p className={styles.title}>{t('create_bottle.choose_type_bank')}</p>
        {/* {window.innerHeight} */}

        <div className={styles.main}>
          <div className={styles.list}>
            {TYPES_OF_BOTTLE.map((type) => (
              <div
                key={type.type}
                className={styles.item + ' ' + (activeType === type.type && styles.active)}
                onClick={() => setActiveType(type.type)}
              >
                <div className={styles.item_header}>
                  <div className={styles.item_checkbox}>
                    {activeType === type.type && <Icon name='type_of_bottle_mark' />}
                  </div>
                  <p className={styles.item_title}>{type.name}</p>
                </div>
                <p className={styles.item_description}>{type.description}</p>
              </div>
            ))}
          </div>
        </div>

        <CustomButton
          onClick={addTypeIntoStorage}
          className={styles.button}
          variant={activeType === '' ? 'not-active' : 'contained'}
          color='white'
        >
          {t('type_of_bottle.button.text')}
        </CustomButton>
      </div>
    </div>
  )
}

export default ChooseTypeOfBottle
